<template>
  <div>
    <preloader v-if="showPreloader"></preloader>
    <camera v-if="showCamera"
      :imagesList="photoType"
      v-on:closecamera="closeCamera">
    </camera>
    <signatures v-if="showSignature"
      :signaturesList="photoType"
      v-on:closesignature="closeSignature">
    </signatures>
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      variant="primary"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
        {{allertMessage}}
    </b-alert>
    <div class="container">
      <base-button @click="goBack" type="primary" class="mt-1">Back</base-button>
      <piratesForm></piratesForm>
    </div>
  </div>
</template>

<script>
import alertMixin from '../mixins/alertMixin'
import standsMixin from '../mixins/standsMixin'
import jobsMixin from '../mixins/jobsMixin'
import timestampMixin from '../mixins/timestampMixin'
import camera from '../../components/Camera'
import signatures from '../../components/Signatures'
import jobActionsMixin from '../mixins/jobActionsMixin'
import jobActionFormMixin from '../mixins/jobActionFormMixin'
import piratesForm from '../../components/PiratesForm'

export default {
  data () {
    return {
      showPreloader: false,
      showCamera: null,
      showSignature: false,
      images: [],
      signatures: [],
      photoType: null,
      jobAction: null
    }
  },
  computed: {
    token () {
      return this.$store.state.user.token
    }
  },
  mixins: [alertMixin, standsMixin, jobsMixin, jobActionsMixin, timestampMixin, jobActionFormMixin],
  methods: {
    goBack () {
      this.$router.push('/forms')
    }
  },
  components: {
    camera,
    signatures,
    piratesForm
  }
}
</script>
<style lang="css">
  .link {
    cursor: pointer;
  }
  .overflowbody {
    height: 100vh;
    overflow: hidden;
  }
</style>
